// ─────────────────────────────────────────────────────────────────────────────
// companyInfo.js 
// ─────────────────────────────────────────────────────────────────────────────

export const companyInfo = {
  name:       'Salient Agrinutrition Pvt. Ltd.',
  shortName:  'Salient Agrinutrition',
  tagline:    'Global quality,Local Care',

  vision: 'To empower agriculture and livestock sectors with world-class nutritional inputs that boost productivity, strengthen resilience, and uplift rural economies.',

  mission: 'To deliver effective agricultural and nutritional solutions backed by expert guidance, training, and responsive service - enabling farmers to achieve higher yields and sustainable practices.',

  description: 'A globally connected livestock nutrition partner committed to advancing Sri Lanka\'s animal production sector through science-driven, performance-focused solutions.',

  about: 'We source and distribute premium feed additives, mineral solutions, performance enhancers, gut health products, and specialty nutritional inputs from internationally recognized manufacturers. By connecting global innovation with local application, we integrate advanced nutritional technologies across poultry and dairy, and swine production systems .',

  addresses: {
    office: {
      label:   'Office',
      line1:   'No.51/D, P.T.S. Avenue',
      line2:   'Dalugama, ',
      city:    'Kelaniya',
      country: 'Sri Lanka',
      full:    'No.51/D, P.T.S. Avenue, Dalugama, Kelaniya, Sri Lanka',
    },
    warehouse: {
      label:   'Warehouse',
      line1:   'Epaladeniya Waththa',
      line2:   'Off-Hettipola Road, Epaladeniya',
      city:    'Kuliyapitiya',
      country: 'Sri Lanka',
      full:    'Epaladeniya Waththa, Off-Hettipola Road, Epaladeniya, Kuliyapitiya',
      mapUrl:  'https://maps.app.goo.gl/aHnXFYAf7eJS6Ach8?g_st=aw',
    },
  },

  phones: [
    { number: '+94718919034', display: '+94 718 919 034', label: 'Primary' },
    { number: '+94703813000', display: '+94 703 813 000', label: 'Secondary' },
    { number: '+94373158888', display: '+94 373 158 888', label: 'Office' },
  ],

  email: 'salientagrinutrition@gmail.com',

  socials: [
    { label: 'Facebook',  href: 'https://web.facebook.com/people/Salient-Agrinutrition/61576695466705/',       platform: 'facebook'  },
    { label: 'Instagram', href: 'https://www.instagram.com/salientagrinutrition/',       platform: 'instagram' },
    { label: 'LinkedIn',  href: 'https://www.linkedin.com/authwall?trk=bf&trkInfo=AQG14EbfrhsYIQAAAZ2085rIzOFc-tb2Q7mOL3Ht62YEAqM5hLSOo6ta4yzXcMWpxxl2tHDUaNfkaWftZCm8FydsBhMyD4S0_IZTYdvOpxJRFfeWIkkIDpyCfWS2OEt9iQrgOTg=&original_referer=&sessionRedirect=https%3A%2F%2Flk.linkedin.com%2Fcompany%2Fsalient-agrinutrition', platform: 'linkedin'  },
    { label: 'WhatsApp',  href: 'https://wa.me/94718919034',                        platform: 'whatsapp'  },
  ],

  // ── REAL services from content document ──────────────────────────────────
  services: [
    {
      id:          'technical-consultation',
      title:       'On-Farm Technical Consultation',
      description: 'Our technical team visits farms directly to assess nutritional programmes, diagnose challenges, and provide tailored recommendations for improving productivity and animal health.',
      icon:        'consultation',
      delivery:    ['Field Visits'],
    },
    {
      id:          'lab-testing',
      title:       'Laboratory Testing',
      description: 'We support clients with access to laboratory testing services to assess feed quality, water quality, and animal health parameters - enabling data-driven nutritional decisions.',
      icon:        'lab',
      delivery:    ['Lab Analysis', 'Field Sampling'],
    },
    {
      id:          'training-programs',
      title:       'Training Programmes',
      description: 'We conduct training programmes for farmers, feed millers, and veterinarians on best practices in livestock nutrition, biosecurity, and the correct use of nutritional products.',
      icon:        'training',
      delivery:    ['On-Farm Workshops', 'Group Sessions'],
    },
    {
      id:          'after-sales-support',
      title:       'After-Sales Technical Support',
      description: 'Responsive expert support is available after every sale - our team is reachable via field visits, WhatsApp, and our dedicated hotline for fast answers to technical questions.',
      icon:        'support',
      delivery:    ['Field Visits', 'WhatsApp', 'Phone Hotline'],
    },
  ],

  stats: [
    { value: '20+',  label: 'Products',          description: 'Across 8 product categories' },
    { value: '3+',   label: 'Global Suppliers',  description: 'Internationally certified manufacturers' },
    { value: '2',    label: 'Livestock Sectors', description: 'Poultry and dairy production systems' },
    { value: '24/7', label: 'Expert Support',    description: 'Technical guidance via WhatsApp & hotline' },
  ],

  values: [
    {
      title:       'Quality',
      description: 'Premium inputs sourced from internationally certified manufacturers including GMP+ and FAMI-QS certified suppliers.',
      icon:        'quality',
    },
    {
      title:       'Expertise',
      description: 'Science-driven solutions backed by on-farm technical consultation, training, and responsive expert guidance.',
      icon:        'expertise',
    },
    {
      title:       'Partnership',
      description: 'Long-term collaboration with feed millers, integrators, veterinarians, and commercial producers across Sri Lanka.',
      icon:        'partnership',
    },
    {
      title:       'Performance',
      description: 'Measurable improvements in feed efficiency, growth rates, eggshell quality, immunity, and overall productivity.',
      icon:        'performance',
    },
    {
      title:       'Sustainability',
      description: 'Empowering farmers to achieve resilient, sustainable livestock operations while reducing antibiotic dependency.',
      icon:        'sustainability',
    },
    {
      title:       'Innovation',
      description: 'Connecting global nutritional innovation - from Germany, France, India, and Vietnam - with local Sri Lankan application.',
      icon:        'innovation',
    },
  ],
}

export default companyInfo